<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Account">Account</span>
      </div>

      <!-- End -->
      <div class="app-toolbar-end">
        <app-shopping-cart-top-bar-button></app-shopping-cart-top-bar-button>
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="account"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <mat-card appearance="outlined">
        <mat-card-content>
          <div class="accountOutsideContainer">
            <div class="accountContainer">
              <app-contact></app-contact>
              <app-ecommerce></app-ecommerce>
  <!--            <app-subscription></app-subscription>-->
  <!--            <app-payment></app-payment>-->
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>



